// const COLORS = {
//  PRIMARY_COLOR: "#281e41",
//  SECONDARY_COLOR: "#8a39e1",
//  ACCENT_COLOR: "#293A80",
//  ACCENT_HOVER_COLOR: "#010038",
//  WHITE: "#FFFFFF",
//  BLACK: "#000000",
//  DISABLED_BG_DARK: "#424244",
//  DISABLED_BG_LIGHT: "#E1E1E0",
//  DISABLED_C_DARK: "#78787a",
//  DISABLED_C_LIGHT: "#ACACAD",
// };

// export default COLORS;

const COLORS = {
  PRIMARY_COLOR: "#010038",
  SECONDARY_COLOR: "#8a39e1",
  ACCENT_COLOR: "#8f69e7cc",
  ACCENT_HOVER_COLOR: "#281e41",
  ACCENT_HOVER_DARK_COLOR: "#6610F2",
  WHITE: "#f3f4f5",
  BLACK: "#000000",
  DISABLED_BG_DARK: "#424244",
  DISABLED_BG_LIGHT: "#E1E1E0",
  DISABLED_C_DARK: "#78787a",
  DISABLED_C_LIGHT: "#ACACAD",
};

export default COLORS;
